import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgQuestion = (props) => (
  <SvgIcon {...props} title="Question">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#Question_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.88.027c-3.037.39-4.974 3.464-4.02 6.38.572 1.744 2.164 3.078 3.94 3.3.126.016.226.032.222.037a4.337 4.337 0 0 1-.34.043c-3.413.358-6.13 3-6.627 6.443-.177 1.23.031 1.758.695 1.758.535 0 .718-.234.765-.982.269-4.185 4.292-6.81 8.17-5.33.385.146.58.156.81.042.5-.25.562-.977.109-1.29-.347-.238-1.562-.578-2.296-.642-.368-.033-.374-.04-.07-.085 2.621-.389 4.445-2.823 4.1-5.475-.342-2.642-2.807-4.54-5.457-4.2ZM8.073 1.56c2.672.453 3.718 3.76 1.796 5.683C8.1 9.014 5.102 8.307 4.312 5.933c-.8-2.402 1.26-4.795 3.76-4.372Zm8.568 8.953c-3.61.415-6.128 3.183-6.128 6.736 0 5.029 5.204 8.271 9.726 6.06 5.197-2.542 4.94-10.085-.418-12.315-.908-.378-2.276-.585-3.18-.48Zm1.243 1.535c3.724.44 5.792 4.643 3.87 7.87-1.975 3.317-6.741 3.432-8.873.214-2.453-3.703.58-8.605 5.003-8.084Zm-1.172 1.497a2.615 2.615 0 0 0-2.043 2.063c-.156.751.094 1.233.655 1.262.499.027.755-.236.822-.84.106-.952 1.215-1.356 1.886-.687.666.665.262 1.777-.684 1.885-.61.07-.867.317-.844.813.034.687.776.909 1.746.52 1.331-.532 1.977-2.075 1.439-3.435-.456-1.154-1.755-1.843-2.977-1.58Zm.161 6.01c-1.194.421-.89 2.194.378 2.194 1.28 0 1.568-1.793.354-2.202a1.281 1.281 0 0 0-.732.008Z"
          fill="#017163"
        />
      </g>
      <defs>
        <clipPath id="Question_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgQuestion;
